<template>
    <div class="link-tab" v-if="currentInitialized" v-show="show">
        <slot></slot>
    </div>
</template>

<script>
    import {findComponentUpward} from "../../utils/dom";

    export default {
        name: "link-tab",
        props: {
            title: {required: true, type: String},
            initialized: {type: Boolean,},
            destroyedOnHide: {type: Boolean,},
            id: {type: String},
        },
        data() {
            return {
                tabs: null,
                currentInitialized: this.initialized,
                show: false,
            }
        },
        watch: {
            show(newVal, oldVal) {
                if (!newVal && !!oldVal && !!this.destroyedOnHide) {
                    this.currentInitialized = false
                }
            },
        },
        mounted() {
            this.tabs = findComponentUpward(this, 'link-tabs')
            if (!this.tabs) {
                console.error("tab component must be placed in tabs component, can not find parent tabs component!!!")
                return
            }
            this.tabs._addItem(this)
        },
        methods: {},
        beforeDestroy() {
            this.tabs._removeItem(this)
        },
    }
</script>

<style lang="scss">

</style>
